import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from './components/Header';
import CategoryNav from './components/CategoryNav';
import SearchBar from './components/SearchBar';
import NewsList from './components/NewsList';
import HeroCarousel from './components/HeroCarousel';
import BreakingNewsTicker from './components/BreakingNewsTicker';

export default function App() {
  const { t, i18n } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState<string | undefined>();
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [isSearching, setIsSearching] = useState(false);

  const handleCategoryChange = (category: string | undefined) => {
    setSelectedCategory(category);
    setSearchQuery('');
    setIsSearching(false);
  };

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    setSelectedCategory(undefined);
    setIsSearching(!!query);
  };

  return (
    <div className={`min-h-screen hero-background ${i18n.language === 'lo' ? 'lao-text' : ''}`} lang={i18n.language}>
      <Header />
      
      <BreakingNewsTicker />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <HeroCarousel />
        </div>
        
        <SearchBar onSearch={handleSearch} loading={isSearching} />
        
        <CategoryNav 
          selectedCategory={selectedCategory} 
          onCategoryChange={handleCategoryChange} 
        />
        
        <div className="mt-8">
          <NewsList 
            category={selectedCategory} 
            searchQuery={searchQuery}
          />
        </div>
      </main>
      
      <footer className="bg-gray-900 text-white mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-4">{t('header.title')}</h3>
              <p className="text-gray-300 text-sm">
                {t('header.title')} - {t('news.latest')}
              </p>
            </div>
            
            <div>
              <h4 className="text-md font-semibold mb-4">{t('categories.general')}</h4>
              <ul className="space-y-2 text-sm text-gray-300">
                <li><a href="#" className="hover:text-white transition-colors">{t('news.latest')}</a></li>
                <li><a href="#" className="hover:text-white transition-colors">{t('categories.business')}</a></li>
                <li><a href="#" className="hover:text-white transition-colors">{t('categories.technology')}</a></li>
                <li><a href="#" className="hover:text-white transition-colors">{t('categories.sports')}</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-md font-semibold mb-4">{t('header.language')}</h4>
              <ul className="space-y-2 text-sm text-gray-300">
                <li><a href="#" className="hover:text-white transition-colors">ລາວ</a></li>
                <li><a href="#" className="hover:text-white transition-colors">English</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-md font-semibold mb-4">{t('news.share')}</h4>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-300 hover:text-white transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a href="#" className="text-gray-300 hover:text-white transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400">
            <p>&copy; 2024 {t('header.title')}. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
